import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	item: {
		display: 'block',
		paddingTop: 0,
		paddingBottom: 0,
	},
	itemLeaf: {
		display: 'flex',
		paddingTop: 0,
		paddingBottom: 0,
		marginBottom: theme.spacing(1),
	},
	buttonLeaf: {
		justifyContent: 'flex-start',
		textTransform: 'none',
		width: '100%',
		borderRadius: 0,
		border: 'none',
		paddingLeft: 20,
		padding: '12px 24px',
		color: theme.palette.primary[600],
	},
	icon: {
		color: theme.palette.primary[600],
		display: 'flex',
		alignItems: 'center',
		marginRight: theme.spacing(1),
	},
	label: {
		display: 'flex',
		alignItems: 'center',
		marginLeft: 'auto',
	},
	active: {
		color: theme.palette.secondary.main,
		'& $icon': {
			color: theme.palette.secondary.main,
		},
		'&::before': {
			position: 'absolute',
			content: "''",
			display: 'block',
			left: 0,
			height: '100%',
			width: 4,
			backgroundColor: theme.palette.secondary.main,
		},
	},
}));

export default useStyles;
